import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "information-mgmt-list" }

import { ref } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useSelectColumn,
  useInputColumn,
  createDialog,
  BaseButton
} from 'xrk-components';
import RelatedZone from '../components/related-zone.vue';
import { informationList, delInfo } from '../data-source/apis';
import { RELATED_TYPE } from '../constants/index';
import { useRouter, useRoute } from 'vue-router';
import { formatter } from '@/utils';
import QuestionPreview from '../components/question-preview.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'information-form-mgmt-list',
  setup(__props) {

const xrkTableRef = ref();
const router = useRouter();
const route = useRoute();
const onRefreshTabel = () => {
  xrkTableRef.value?.initCurrentList();
};
// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [
    useInputColumn({
      prop: 'title',
      label: '资讯标题',
      config: {
        type: 'text',
        maxlength: 200
      }
    }),
    useInputColumn({
      prop: 'surveyCode',
      label: '表单编号',
      config: {
        type: 'text',
        inputTextReplace: true,
        inputTexts: ['英文字母', '数字'],
        maxlength: 20
      }
    }),
    useSelectColumn({
      prop: 'relationStatus',
      label: '关联专区状态',
      config: {
        options: RELATED_TYPE
      }
    })
  ],
  otherComponents: []
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px'
    }),
    useTableColumn({
      label: '编号ID',
      prop: 'infoCode'
    }),
    useTableColumn({
      label: '资讯标题',
      prop: 'title'
    }),
    useTableColumn({
      label: '作者',
      prop: 'author'
    }),
    useTableColumn({
      label: '关联表单编号',
      prop: 'surveyCode',
      render({ cellValue, row }) {
        return (
          <div>
            <BaseButton
              type="text"
              disabled={!cellValue || !row.surveyId}
              onClick={async () => {
                await createDialog({
                  title: '预览',
                  showClose: true,
                  showFooter: false,
                  customClass: 'zone-mgmt-question-preview',
                  contentRender: () => (
                    <div style="padding:20px">
                      <QuestionPreview
                        projectType={row.sceneType}
                        tempId={row.surveyId}
                      ></QuestionPreview>
                    </div>
                  )
                });
                const dialogElement = document.querySelector(
                  '.zone-mgmt-question-preview'
                );
                if (dialogElement) {
                  (dialogElement as HTMLElement).style.height = '900px';
                  (dialogElement as HTMLElement).style.maxHeight = '900px';
                }
              }}
            >
              {cellValue}
            </BaseButton>
          </div>
        );
      }
    }),
    useTableColumn({
      label: '关联专区状态',
      prop: 'relationStatus',
      formatter({ cellValue }) {
        return RELATED_TYPE[cellValue]?.label;
      }
    }),
    useTableColumn({
      label: '关联专区数量',
      prop: 'relationNum',
      render({ row, cellValue }) {
        return (
          <div>
            <BaseButton
              type="text"
              disabled={cellValue === 0}
              onClick={() => {
                createDialog({
                  width: 800,
                  title: '关联专区',
                  showClose: true,
                  confirmBtnConfig: {
                    show: false
                  },
                  cancelBtnConfig: {
                    show: true,
                    content: '关闭'
                  },
                  contentRender: () => (
                    <>
                      <RelatedZone row={row}></RelatedZone>
                    </>
                  )
                });
              }}
            >
              {cellValue}
            </BaseButton>
          </div>
        );
      }
    }),
    useTableColumn({
      label: '更新时间',
      prop: 'updateAt',
      minWidth: 180,
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '操作',
      prop: 'handlerCol',
      fixed: 'right',
      render: ({ row }) => {
        return (
          <div>
            <BaseButton
              v-resource={[['编辑']]}
              type="text"
              onClick={() => {
                router.push({
                  path: `/main/${route.meta.platFrom}/information-form-mgmt/edit`,
                  query: {
                    id: row.id
                  }
                });
              }}
            >
              编辑
            </BaseButton>
            <BaseButton
              v-resource={[['删除']]}
              type="text"
              disabled={+row.relationStatus === 1}
              onClick={() => {
                createDialog({
                  width: 350,
                  title: '提示',
                  showClose: true,
                  content: '是否确认删除？',
                  beforeConfirm: async done => {
                    await delInfo({ id: row.id, hasForm: 1 });
                    done();
                    onRefreshTabel();
                  }
                });
              }}
            >
              删除
            </BaseButton>
          </div>
        );
      }
    })
  ]
});

const getListAjax = async params => {
  return await informationList({
    ...params,
    relationStatus: params.relationStatus,
    hasForm: 1
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})